'use client';

import React from 'react';
import { motion } from 'framer-motion';
import { Code, CheckCircle2, ArrowRight, Zap } from 'lucide-react';
import styles from './ApiDemo.module.css';

const integrationSteps = [
    {
        title: 'Создание накладных',
        description: 'Автоматически из вашей системы',
        code: `const waybill = await cdek.createWaybill({\n  from: "Moscow",\n  to: "Saint Petersburg",\n  weight: 1.5,\n  type: "express"\n});`,
        icon: Zap,
    },
    {
        title: 'Статусы доставки',
        description: 'Отслеживание в реальном времени',
        code: `cdek.on("statusUpdate", (delivery) => {\n  console.log(\`Delivery \${delivery.id} status: \${delivery.status}\`);\n});`,
        icon: CheckCircle2,
    },
];

export const ApiDemo = () => {
    return (
        <motion.div
            className={styles.container}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
        >
            <motion.div
                className={styles.header}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
            >
                <div className={styles.headerInfo}>
                    <div className={styles.iconWrapper}>
                        <Code className={styles.icon} />
                    </div>
                    <div className={styles.apiType}>REST API & WebSocket</div>
                </div>
                <h2 className={styles.title}>Встройте доставку в ваш сервис</h2>
                <p className={styles.description}>
                    Готовые модули для популярных CMS и фреймворков
                </p>
            </motion.div>

            <div className={styles.stepsContainer}>
                {integrationSteps.map((step, index) => (
                    <motion.div
                        key={index}
                        className={styles.stepItem}
                        initial={{ opacity: 0, x: -20 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ delay: index * 0.15 }}
                    >
                        <div className={styles.stepHeader}>
                            <step.icon className={styles.stepIcon} />
                            <span className={styles.stepTitle}>{step.title}</span>
                        </div>
                        <div className={styles.codeBlock}>
                            <pre>{step.code}</pre>
                        </div>
                        <div className={styles.stepDescription}>{step.description}</div>
                    </motion.div>
                ))}
            </div>

            <motion.div
                className={styles.notification}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.5 }}
            >
                <div className={styles.notificationContent}>
                    <CheckCircle2 className={styles.notificationIcon} />
                    <span className={styles.notificationTitle}>API готово к использованию</span>
                </div>
                <div className={styles.notificationDescription}>
                    Документация и примеры интеграции доступны в личном кабинете
                </div>
            </motion.div>

            <motion.button
                className={styles.actionButton}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.6 }}
            >
                <span className={styles.buttonContent}>
                    Подключить API
                    <ArrowRight className={styles.arrowIcon} />
                </span>
            </motion.button>
        </motion.div>
    );
};
